import { apiRequest } from "@alba-cars/common-modules";
import { PaginatedResponse } from "@/components/common/forms/FormAutoComplete";

export interface DealDriveBrand {
  node: {

    id: number;
    name: string;
    logo?: string;
  }
}

export const getDealDriveBrands = async (search?: string) => {
  const queryParams = new URLSearchParams();
  if (search) {
    queryParams.append("search", search);
  }

  const response = await apiRequest<DealDriveBrand[]>(
    `/dealdrive/brands${search ? `?${queryParams.toString()}` : ""}`,
    {
      next: {
        revalidate: 3600, // Cache for 1 hour
        tags: ["dealdrive-brands"],
      },
    },
  );

  return response;
};

export const getDealDriveBrandsPaginated = async (
  inputValue: string,
  page?: number,
  filter?: Record<string, string>,
): Promise<PaginatedResponse<{ label: string; value: string }>> => {
  try {
    const brands = await getDealDriveBrands(inputValue);

    const formattedBrands = brands.map((brand) => ({
      label: brand.node.name,
      value: brand.node.id.toString(),
    }));

    return {
      data: formattedBrands,
      meta: { currentPage: 1, totalPages: 1, hasNextPage: false },
    };
  } catch (error) {
    console.error("Error fetching DealDrive brands:", error);
    return {
      data: [],
      meta: { currentPage: 1, totalPages: 1, hasNextPage: false },
    };
  }
};
